var map = {
	"./1.jpg": 8821,
	"./10.jpg": 4632,
	"./2.jpg": 4615,
	"./3.jpg": 2526,
	"./4.jpg": 8646,
	"./5.jpg": 3306,
	"./6.jpg": 6254,
	"./7.jpg": 6736,
	"./8.jpg": 7642,
	"./9.jpg": 2929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1983;